import { DashMenuTypes } from './dash-menu-types';

export const toggleDashMenuOpen = () => ({
  type: DashMenuTypes.TOGGLE_MENU_OPEN,
});

export const toggleDashMenuFixed = () => ({
  type: DashMenuTypes.TOGGLE_MENU_FIXED,
});
